window.addEventListener('load', () => {
  if (window.location.hash !== '#ingredients') return;

  const section = document.getElementById('ingredients');
  if (!section) return;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      section.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
    });
  });
});